import { load } from "../../events/load";

const MOBILE_BREAKPOINT = 992; // must match @include mobile($max: 992px) in SCSS

const isMobile = () => window.innerWidth <= MOBILE_BREAKPOINT;

const initFixedSidebar = () => {
  const sidebar = document.querySelector(".site-nav");
  const footer = document.querySelector(".footer");
  if (!sidebar) return;

  const spacer = document.createElement("div");
  spacer.className = "site-nav-spacer";
  sidebar.insertAdjacentElement("afterend", spacer);

  let initialWidth = 0;
  let fixedWidth = 0;
  let isFixed = false;
  const scrollThreshold = 1;

  /**
   * Recalculate sidebar dimensions.
   * Must be called only when sidebar is visible (desktop).
   */
  const recalcDimensions = () => {
    const wasFixed = sidebar.classList.contains("is-fixed");
    
    // 1. Temporarily disable transitions to get instant "natural" measurements
    const originalTransition = sidebar.style.transition;
    sidebar.style.transition = "none";
    
    // 2. Reset everything to measure natural size
    sidebar.classList.remove("is-fixed");
    sidebar.style.width = "";
    sidebar.style.top = "";
    spacer.style.width = "0"; 
    document.documentElement.style.removeProperty("--sidebar-width");
    
    // 3. Force reflow 
    initialWidth = sidebar.offsetWidth;
    
    // 4. Update CSS variable and spacer
    if (initialWidth > 0) {
      document.documentElement.style.setProperty("--sidebar-width", `${initialWidth}px`);
      spacer.style.width = `${initialWidth}px`;
    }

    // 5. Restore fixed state if needed
    if (wasFixed || isFixed) {
      sidebar.classList.add("is-fixed");
    }

    // 6. Re-enable transitions after a tiny delay so the browser doesn't animate the snap-back
    setTimeout(() => {
      sidebar.style.transition = originalTransition;
    }, 50);
  };

  /**
   * Remove the inline --sidebar-width override so the CSS :root value takes over.
   */
  const clearDimensions = () => {
    document.documentElement.style.removeProperty("--sidebar-width");
    spacer.style.width = "";

    if (isFixed || sidebar.classList.contains("is-fixed")) {
      sidebar.classList.remove("is-fixed");
      sidebar.style.width = "";
      sidebar.style.top = "";
      sidebar.style.height = "";
      isFixed = false;
    }
  };

  const handleScroll = () => {
    if (isMobile()) return;

    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    const viewportHeight = window.innerHeight;

    if (scrollY > scrollThreshold) {
      if (!isFixed) {
        sidebar.classList.add("is-fixed");
        isFixed = true;
      }

      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < viewportHeight) {
          const newTop = footerRect.top - viewportHeight - 27;
          sidebar.style.top = `${newTop}px`;
        } else {
          sidebar.style.top = "0px";
        }
      }
    } else {
      if (isFixed) {
        sidebar.classList.remove("is-fixed");
        sidebar.style.width = "";
        sidebar.style.top = "";
        sidebar.style.height = "";
        isFixed = false;
      }
    }
  };

  // Handle viewport resize (e.g. mobile ↔ desktop switch)
  let resizeTicking = false;
  window.addEventListener("resize", () => {
    if (!resizeTicking) {
      window.requestAnimationFrame(() => {
        if (isMobile()) {
          clearDimensions();
        } else {
          recalcDimensions();
          handleScroll();
        }
        resizeTicking = false;
      });
      resizeTicking = true;
    }
  }, { passive: true });

  // Scroll listener
  let scrollTicking = false;
  window.addEventListener("scroll", () => {
    if (!scrollTicking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  // Initial setup
  if (isMobile()) {
    // Do NOT set --sidebar-width — let CSS :root value handle the grid
    clearDimensions();
  } else {
    recalcDimensions();
    handleScroll();
  }
};

load(initFixedSidebar);

